import { useLocation } from '@okapi/router-react';
import { INSP_GALLERY_ELEMENT_BLOCK } from 'common/consts/insp-gallery-element-block.consts';

export const useGAElementBlock = () => {
  const [path] = useLocation();
  const pathParsed = path
    .split('/')
    .filter(item => !!item)
    .join('-');
  return `${pathParsed} / ${INSP_GALLERY_ELEMENT_BLOCK}`;
};
